import * as React from "react"
import type { IconProps } from "../types"

const VesselMini = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 12, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          fill={color}
          d="M6.00047 5.73907L1.47464 6.83995C1.60601 7.86223 1.94088 8.63135 2.5019 9.49779L0.929688 9.83773L1.08819 10.5708L3.68797 10.0087L6.00047 10.5087L8.31297 10.0087L10.9127 10.5708L11.0712 9.83773L9.49903 9.49779C10.0601 8.63135 10.3949 7.86223 10.5263 6.83995L6.00047 5.73907Z"
        />
        <path
          fill={color}
          d="M4.5 1V3H2.5V5.81889L6.0014 4.96719L9.5 5.8182V3H7.5V1H4.5Z"
        />
      </svg>
    )
  }
)
VesselMini.displayName = "VesselMini"

export default VesselMini